
import axiosInstance from "./AxiosInstance";

export default function PoliticalPartyService() {
    // axiosInstance.get(this.endpoint);
    this.endpoint = "/api/politicalparties"
    this.getAllPoliticalParties = () => {
        var url = `${this.endpoint}?PageIndex=1&PageSize=100000000`;
        return axiosInstance.get(url).then((response) => response.data);
    };

    this.getAllPolitical_proportional_candidates = (politicalPartyID, eventID) => {
        var url = `${this.endpoint}/${politicalPartyID}/proportional-candidates/event/${eventID}`;
        return axiosInstance.get(url).then((response) => response.data);
    };
    this.updateAllPolitical_proportional_candidatesOrder = (data) => {
        var url = `${this.endpoint}/proportional-candidates/candidate-order`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };

    this.getAllPolitical_proportional_candidates_documents = (politicalPartyID, eventID) => {
        var url = `${this.endpoint}/${politicalPartyID}/proportional-documents/event/${eventID}`;
        return axiosInstance.get(url).then((response) => response.data);
    };

    this.add_proportional_upload_documents = (data) => {
        var url = `${this.endpoint}/proportional-documents`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };

    this.add_proportional_member = (data) => {
        var url = `${this.endpoint}/proportional-candidates`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };

    this.edit_proportional_member = (data, id) => {
        var url = `${this.endpoint}/proportional-candidates/${id}`;
        return axiosInstance.patch(url, data).then((response) => response.data);
    };
    this.delete_proportional_member = (data) => {
        var url = `${this.endpoint}/proportional-candidates/${data?.partyProportionalCandidateID}`;
        return axiosInstance.delete(url).then((response) => response.data);
    };








    this.createParty = (data) => {
        var url = `${this.endpoint}`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };
    this.updateParty = (data) => {
        var url = `${this.endpoint}/${data.politicalPartyID}`;
        return axiosInstance.patch(url, data).then((response) => response.data);
    };

    this.getAllPoliticalPartyByID = (id) => {
        var url = `${this.endpoint}/${id}`;
        return axiosInstance.get(url).then((response) => response.data);
    };




    this.addPartyRepresentative = (data) => {
        var url = `${this.endpoint}/PartyRepresentatives`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };
    this.deletePartyRepresentative = (id) => {
        var url = `${this.endpoint}/PartyRepresentatives/${id}`;
        return axiosInstance.delete(url).then((response) => response.data);
    };
    this.getPartyRepresentatives = (id) => {
        var url = `${this.endpoint}/PartyRepresentatives/${id}`;
        return axiosInstance.get(url).then((response) => response.data);
    };
    this.downloadExecutiveMemberSignature = (data) => {
        var url = `${this.endpoint}/DownloadExecutiveMemberSignature`;
        return axiosInstance.post(url, data, {
            responseType: 'blob',
        }).then((response) => response.data);
    };
    this.deletePartyDocument = (data) => {
        var url = `${this.endpoint}/DeletePoliticalPartyDocument`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };
    this.deleteExecutiveMember = (data) => {
        var url = `${this.endpoint}/DeletePartyExecutiveMember`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };

    this.deletePartyAgent = (eventAgentID) => {
        var url = `${this.endpoint}/agents/${eventAgentID}`;
        return axiosInstance.delete(url, eventAgentID).then((response) => response.data);
    }
    this.deletePartyDocuments = (id) => {
        var url = `${this.endpoint}/documents/${id}`;
        return axiosInstance.delete(url).then((response) => response.data);
    }

    this.deletePartyMember = (data) => {
        var url = `${this.endpoint}/registered-members/${data?.partyRegisteredMemberID}`;
        return axiosInstance.delete(url).then((response) => response.data);
    }
    this.getMembersNotExecutive = (id) => {
        var url = `${this.endpoint}/GetPartyMembersNotExecutive/${id}`;
        return axiosInstance.get(url).then((response) => response.data);
    };

    this.getPartyRequirements = (id, membershipPeriodID) => {
        var url = `${this.endpoint}/${id}/requirements`;
        return axiosInstance.get(url).then((response) => response.data);
    };





    this.deActivatePoliticalParty = (id) => {
        var url = `${this.endpoint}/ChangeStatusPoliticalParty/${id}`;
        return axiosInstance.post(url).then((response) => response.data);
    };
    this.getAvailableExecutiveRoles = (id, partyExecutiveTermID) => {
        var url = `${this.endpoint}/${id}/excecutive-roles/executiveterm/${partyExecutiveTermID}`;
        return axiosInstance.get(url).then((response) => response.data);
    };
    this.getExecutiveDetails = (data) => {
        var url = `${this.endpoint}/GetVoterDetailsByRegNumber`
        return axiosInstance.post(url, data).then((response) => response.data?.VoterDetails);
    };
    this.addExecutiveMember = (data) => {
        var url = `${this.endpoint}/AddExecutiveMember`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };
    this.getExecMembersByParty = (id) => {
        var url = `${this.endpoint}/GetPartyExecutiveMembers/${id}`;
        return axiosInstance.get(url).then((response) => response.data);
    };
    this.getRegisteredMembersByParty = (id, membershipPeriodID = null, params) => {
        var url = `${this.endpoint}/${id}/registered-members?PageIndex=${params.page}&PageSize=${params.pageSize}${membershipPeriodID != null ? `&membershipPeriodID=${membershipPeriodID}` : ''}`;
        return axiosInstance.get(url, { params: params }).then((response) => response.data);
    };

    this.getPartyAgentMembersByParty = (params) => {
        var url = `${this.endpoint}/${params.politicalPartyID}/agents`;
        return axiosInstance.get(url, { params: { ...params, PageIndex: 1, PageSize: 100000000 } }).then((response) => response.data);
    }

    this.addPartyAgentMemberByParty = (data) => {
        var url = `${this.endpoint}/agents`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }

    this.verifyRegisteredPartyMembersCsv = (data) => {
        var url = `${this.endpoint}/CheckPoliticalPartyMembersCSVv2`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }
    this.addCsvMembers = (data) => {
        var url = `${this.endpoint}/registered-members/files`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }

    this.addManualMembers = (data) => {
        var url = `${this.endpoint}/registered-members`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }

    this.deleteExcecutiveMemberRole = (data) => {
        var url = `${this.endpoint}/excecutive-members/${data?.partyExecutiveMemberID}`;
        return axiosInstance.delete(url).then((response) => response.data);
    }
    this.updateExcecutiveMemberRole = (data) => {
        var url = `${this.endpoint}/excecutive-members/${data?.partyExecutiveMemberID}`;
        return axiosInstance.patch(url, data).then((response) => response.data);
    }



    this.AddExcecutiveMembers = (data) => {
        var url = `${this.endpoint}/excecutive-members`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }


    this.getExcecutiveMembers = (partyID, partyExecutiveTermID) => {
        var url = `${this.endpoint}/${partyID}/excecutive-members/executiveterm/${partyExecutiveTermID}`;
        return axiosInstance.get(url).then((response) => response.data);
    }

    this.getDocumentsByParty = (id, membershipPeriodID) => {
        var url = `${this.endpoint}/${id}/documents?PageIndex=1&PageSize=10000000&membershipPeriodID=${membershipPeriodID}`;
        return axiosInstance.get(url).then((response) => response.data);
    };
    // this.downloadDocumentsByParty = (id) => {
    //     var url = `${this.endpoint}/${id}/documents?PageIndex=1&PageSize=10000000`;
    //     return axiosInstance.get(url).then((response) => response.data);
    // };
    this.createDocument = (data) => {
        var url = `${this.endpoint}/PoliticalPartyDocuments`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };


    this.createDocuments = (data, params) => {
        var url = `${this.endpoint}/${params.politicalPartyID}/documents`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };

    this.getNotRegisteredMembersByParty = (id, membershipPeriodID, params) => {
        var url = `${this.endpoint}/${id}/member-files/records?Registered=false&PageIndex=${params.page}&PageSize=${params.pageSize}&membershipPeriodID=${membershipPeriodID}`;
        return axiosInstance.get(url, { params: params }).then((response) => response.data);
    };

    this.getUsersByID = (id) => {
        var url = `${this.endpoint}/${id}/users`;
        return axiosInstance.get(url).then((response) => response.data);
    };

    this.createUser = (data) => {
        var url = `${this.endpoint}/users`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };




    this.getExecutiveTerms = async (politicalPartyID) => {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${politicalPartyID}/executive-terms`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }
    this.createExecutiveTerms = async (data) => {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/executive-terms`, data);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }




    this.updateExecutiveTerms = async (data) => {
        try {
            const response = await axiosInstance.patch(`${this.endpoint}/executive-terms/${data.partyExecutiveTermID}`, data);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }
}


